import React, { useEffect, useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper, Typography,
} from '@mui/material';

const DifficultyPriorityTable = ({ difficultyPriorityData = null }) => {
  const [data, setData] = useState([]);

  const [tingkatKesulitan, setTingkatKesulitan] = useState([
    'Mudah',
    'Medium',
    'Sulit',
  ]);

  const [priority, setPriority] = useState(['Low', 'Medium', 'High']);

  useEffect(() => {
    if (difficultyPriorityData) {
      setTingkatKesulitan(difficultyPriorityData.tingkatKesulitan);
      setPriority(difficultyPriorityData.priority);
      setData(difficultyPriorityData.data);
    }
  }, [difficultyPriorityData]);

  function getCellColor(priority) {
    if (priority === 'Low') {
      return '#cbff70';
    } else if (priority === 'Medium') {
      return '#ffe069';
    } else if (priority === 'High') {
      return '#ff8080';
    } else {
      return 'white';
    }
  }

  return (
    data.length > 0 && (
      <div>
        <Typography variant="h6" gutterBottom component="div">
          Panduan Penentuan Due Date
        </Typography>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  <div style={{ display: 'flex' }}>
                    <span>Prioritas</span>
                    <span
                      style={{
                        borderRight: '1px solid black',
                        paddingRight: '10px',
                        marginRight: '10px',
                        transform: 'skew(20deg)',
                      }}
                    ></span>
                    <span>Tingkat Kesulitan</span>
                  </div>
                </TableCell>
                {tingkatKesulitan.map((p) => (
                  <TableCell key={p}>{p}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {priority.map((t, index) => (
                <TableRow key={t}>
                  <TableCell
                    style={{
                      backgroundColor: getCellColor(t),
                      fontWeight: 'bold',
                    }}
                  >
                    {t}
                  </TableCell>
                  {data[index].map((d, i) => (
                    <TableCell key={i}>{d}</TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    )
  );
};

export default DifficultyPriorityTable;
